export type TipoPieza = "incisivo" | "canino" | "premolar" | "molar";

export interface SiluetaDiente {
  path: string;
  vbW: number;
  vbH: number;
  cejRatio: number;
}

/*
 * Siluetas #tooth-base de ZoliQua/React-Odontogram-Modul
 * https://github.com/ZoliQua/React-Odontogram-Modul — MIT License
 * Copyright (c) 2026 Zoltán Dul
 */
const SILUETAS: Record<TipoPieza, SiluetaDiente> = {
  incisivo: {
    vbW: 36,
    vbH: 64,
    cejRatio: 0.4,
    path: "M17.2.9c-2.4,4.5-3.3,9.5-3.6,14.5-.3,4.6-.9,9-1.3,13.6-.3,3.2-1.3,6.2-2.8,9-1.6,3.5-3.1,8.2-3.3,12.3-.3,6,2,11.1,8.1,11.1s16.5,1.1,16.5-4.3-.3-11.8-2.3-17-.3-.8-.5-1.2c-1.1-2.4-2.1-5.9-1.9-8.3.5-6.5-1.8-13.8-3-20.3-.4-3.6-1.2-7.1-4.2-9.4",
  },
  canino: {
    vbW: 36,
    vbH: 64,
    cejRatio: 0.38,
    path: "M17.1,2.3c-.7,1.2-1.6,2.5-2.1,3.9-1.6,5-1.9,11-2.9,16-.7,6.7-3.6,11.9-4.6,18.3-.7,4.1.9,7.7,2.3,11.5,1.4,5.1,4.2,13.2,10.3,11,4.9-2.1,8.4-11.8,9.1-16.8.5-3.6.5-7.8-1.2-11.2s-3-4.9-3.3-8.1c-.8-4.7-1.3-13.3-2.3-17.9-.4-2.6-1.9-4.6-3.6-6.4",
  },
  premolar: {
    vbW: 32.3,
    vbH: 64,
    cejRatio: 0.42,
    path: "M13.2,18.8c.3,1.9.9,4.3,2.6,5.3,1.5.9,2.9-.4,3.4-1.8,1.7-4.8.3-10.7,2.2-15.5.8-1.7,2.6-1.5,3.4.2,1,1.9,1.1,4.3,1.4,6.5.3,3.8-.7,7.3-1.6,11-1,4-1.2,8.3,0,12.4,1.8,8,7.5,21.1-2,24.4-1.4.2-2.9-.5-4.5-.9-3-1-5.1,1-8,1.5-8.9,1.4-6.7-14.5-4.9-19.4.9-2.3,1.9-4.7,2.1-7.3.3-5.2-1.1-10.8-.8-15.9,0-3.3.5-6.8,1.2-10.1.2-1.7,2.2-5.9,3.9-3.2,1.4,3.9.9,8.8,1.6,12.6,0,0,0,.2,0,.2Z",
  },
  molar: {
    vbW: 40.6,
    vbH: 64,
    cejRatio: 0.45,
    path: "M20.1,24.1c1.9.9,3.6-.4,4.2-1.8,2.1-4.8.4-10.7,2.7-15.5,1-1.7,3.2-1.5,4.2.2,1.2,1.9,1.4,4.3,1.7,6.5.4,3.8-.9,7.3-2,11-1.2,4-1.5,8.3,0,12.4,2.2,8,9.3,21.1-2.6,24.4-1.7.2-3.6-.5-5.6-.9-3.7-1-6.4,1-10,1.5-11.1,1.4-8.4-14.5-6-19.4,1.1-2.3,2.4-4.7,2.6-7.3.4-5.2-1.4-10.8-1-15.9,0-3.3.6-6.8,1.5-10.1.2-1.7,2.7-5.9,4.9-3.2,1.7,3.9,1.1,8.8,2,12.6,0,0,1.3,4.5,3.4,5.5Z",
  },
};

export function tipoPieza(fdi: string): TipoPieza {
  const cuadrante = parseInt(fdi[0], 10);
  const pieza = parseInt(fdi[1], 10);
  const temporal = cuadrante >= 5;
  if (temporal) {
    if (pieza <= 2) return "incisivo";
    if (pieza === 3) return "canino";
    return "molar";
  }
  if (pieza <= 2) return "incisivo";
  if (pieza === 3) return "canino";
  if (pieza <= 5) return "premolar";
  return "molar";
}

export function siluetaDiente(fdi: string): SiluetaDiente {
  return SILUETAS[tipoPieza(fdi)];
}
